<template>
  <div class="skeleton-page" aria-busy="true">
    <!-- Topbar -->
    <div class="topbar">
      <div class="left-actions">
        <!-- Skeleton for select -->
        <skeleton width="27rem" height="2rem" border-radius="4px" />
      </div>
      <div class="right-actions">
        <!-- Skeletons for the two buttons -->
        <skeleton
          width="6rem"
          height="2rem"
          border-radius="4px"
          class="btn-skeleton"
        />
        <skeleton
          width="8rem"
          height="2rem"
          border-radius="4px"
          class="btn-skeleton"
        />
      </div>
    </div>

    <!-- Tabs -->
    <div class="tabs">
      <!-- Skeletons for the three tab buttons -->
      <skeleton
        width="8rem"
        height="2rem"
        border-radius="4px"
        class="tab-skeleton"
      />
      <skeleton
        width="7rem"
        height="2rem"
        border-radius="4px"
        class="tab-skeleton"
      />
      <skeleton width="6rem" height="2rem" border-radius="4px" />
    </div>

    <!-- Content -->
    <div class="content">
      <!-- Section 1 -->
      <div class="section">
        <!-- Heading 1 -->
        <skeleton
          width="10rem"
          height="1rem"
          border-radius="4px"
          class="heading-skeleton"
        />
        <skeleton width="6rem" height="1rem" class="mb-2" border-radius="4px" />
        <skeleton width="100%" height="1px" class="divider-skeleton" />

        <!-- Heading 2 -->
        <skeleton
          width="8rem"
          height="1rem"
          border-radius="4px"
          class="heading-skeleton"
        />
        <skeleton width="5rem" height="1rem" class="mb-2" border-radius="4px" />
        <skeleton width="100%" height="1px" class="divider-skeleton" />

        <!-- Heading 3 -->
        <skeleton
          width="6rem"
          height="1rem"
          border-radius="4px"
          class="heading-skeleton"
        />
        <skeleton width="8rem" height="1rem" class="mb-2" border-radius="4px" />
        <skeleton width="100%" height="1px" class="divider-skeleton" />

        <!-- Heading 4 -->
        <skeleton
          width="9rem"
          height="1rem"
          border-radius="4px"
          class="heading-skeleton"
        />
        <skeleton
          width="12rem"
          height="1rem"
          class="mb-2"
          border-radius="4px"
        />
      </div>

      <!-- Section 2 -->
      <div class="section">
        <!-- Heading 1 -->
        <skeleton
          width="12rem"
          height="1rem"
          border-radius="4px"
          class="heading-skeleton"
        />
        <skeleton
          width="14rem"
          height="1rem"
          class="mb-2"
          border-radius="4px"
        />
        <skeleton width="100%" height="1px" class="divider-skeleton" />

        <!-- Heading 2 -->
        <skeleton
          width="10rem"
          height="1rem"
          border-radius="4px"
          class="heading-skeleton"
        />
        <skeleton width="4rem" height="1rem" class="mb-2" border-radius="4px" />
        <skeleton width="100%" height="1px" class="divider-skeleton" />

        <!-- Heading 3 -->
        <skeleton
          width="9rem"
          height="1rem"
          border-radius="4px"
          class="heading-skeleton"
        />
        <skeleton width="8rem" height="1rem" class="mb-2" border-radius="4px" />
        <skeleton width="100%" height="1px" class="divider-skeleton" />

        <!-- Heading 4 -->
        <skeleton
          width="11rem"
          height="1rem"
          border-radius="4px"
          class="heading-skeleton"
        />
        <skeleton width="6rem" height="1rem" class="mb-2" border-radius="4px" />
      </div>

      <!-- Section 3 -->
      <div class="section">
        <!-- Heading 1 -->
        <skeleton
          width="14rem"
          height="1rem"
          border-radius="4px"
          class="heading-skeleton"
        />
        <!-- Three lines of text -->
        <skeleton width="90%" height="1rem" class="mb-2" border-radius="4px" />
        <skeleton width="80%" height="1rem" class="mb-2" border-radius="4px" />
        <skeleton width="70%" height="1rem" class="mb-2" border-radius="4px" />
        <skeleton width="100%" height="1px" class="divider-skeleton" />

        <!-- Heading 2 -->
        <skeleton
          width="8rem"
          height="1rem"
          border-radius="4px"
          class="heading-skeleton"
        />
        <!-- Text -->
        <skeleton width="7rem" height="1rem" class="mb-2" border-radius="4px" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "primevue/skeleton";
</script>

<style scoped>
.skeleton-page {
  background-color: #f8f8f8;
  margin: 0;
  font-family: sans-serif;
}

.topbar {
  display: flex;
  align-items: center;
  padding: 2rem 4rem;
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  justify-content: space-between;
}

.left-actions,
.right-actions {
  display: flex;
  align-items: center;
}

.btn-skeleton {
  margin-left: 1rem;
}

.tabs {
  display: flex;
  align-items: center;
  gap: 3rem;
  background-color: #fff;
  padding: 1rem 4rem;
  border-bottom: 1px solid #ddd;
}

.tab-skeleton {
  margin-right: 0;
}

.content {
  display: flex;
  flex-wrap: wrap;
  gap: 2.5rem;
  background-color: #fff;
  padding: 2rem 4rem;
}

.section {
  flex: 1 1 300px;
  min-width: 250px;
  margin-bottom: 2rem;
}

.heading-skeleton {
  margin-bottom: 0.75rem;
}

.divider-skeleton {
  margin-bottom: 1.25rem;
}

.mb-2 {
  margin-bottom: 1rem;
}
</style>
